import { render } from "./Label.vue?vue&type=template&id=4885bb2b&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=4885bb2b&scoped=true&lang=css"

import exportComponent from "/home/yazgaroth/code/guinze/guinze.v3/agenda/v3/prod/frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4885bb2b"]])

export default __exports__